module.exports = " <div class=von-popover :class=\"{'visible': state == 1, 'visible active': state == 2}\" :style=\"{top: top, left: left, marginTop: marginTop, marginLeft: marginLeft}\"> <div class=von-popover-content :class=\"{'has-close': showClose == 'true'}\"> <slot></slot> <close v-if=\"showClose == 'true'\" @click=hide()></close> </div> <arrow :position=arrowPosition></arrow> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/popover/index.vue
// module id = 241
// module chunks = 0